<template>
  <section>
    <div>
      <el-button size="mini" @click="projectDetail(flow.applyId, flow.flowsource)" type="primary" plain>{{ '详情' }}
      </el-button>

      <!-- 填表人修改权限 -->
      <span
        v-if="flow.flowsource!='5' && flow.flowsource!='33' && (project.leader.id==userData.id||project.creator.id==userData.id) && flow.status!='审批通过'">
        <span v-if="(flow.status == '进行中'||flow.status == '已拒绝'||flow.status == '已取消')">
          <el-button @click="getRouterLink(flow.flowsource, flow.applyId)" size="mini" type="warning" plain>修改
          </el-button>
        </span>

        <el-button v-if="flow.status == '进行中' && !isCanCancel" size="mini" @click="cancelFlow(flow)" type="danger"
          plain>取消</el-button>
      </span>

      <!-- 款项负责人权限 -->
      <span v-if="(flow.flowsource=='5'|| flow.flowsource=='33') && isKxLeader && flow.status!='审批通过'">
        <span v-if="(flow.status == '进行中'||flow.status == '已拒绝'||flow.status == '已取消')">
          <el-button @click="getRouterLink(flow.flowsource, flow.applyId)" size="mini" type="warning" plain>修改
          </el-button>
        </span>

        <el-button v-if="flow.status == '进行中' && !isCanCancel" size="mini" @click="cancelFlow(flow)" type="danger"
          plain>取消</el-button>
      </span>

      <!-- 管理员无限取消权限 -->
      <el-button v-if="flow.status != '已取消' && isCanCancel" size="mini" @click="cancelFlow(flow)" type="danger" plain>取消
      </el-button>

      <!-- 表格下载 -->
      <a :href="baseURL + '/export/' + flow.applyId +'/'+flow.flowsource" target="_blank">
        <!-- 负责人、审批人、管理员可以下载 -->
        <el-button
          v-if="project.leader.id==userData.id || isApprovalUser(flow.approvals) || isSystemAdmin() || backRole('SYSTEM_2')"
          type="success" icon="el-icon-download" size="mini"></el-button>
      </a>
    </div>
    <!-- 取消流程弹窗 -->
    <div class="pop-room" v-if="cancleStatus">
      <a href="javascript:;" @click="cancleStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="取消原因：">
              <el-input size="small" v-model="form.remark" type="textarea" :autosize="{ minRows: 3, maxRows: 6}"
                placeholder="请输入取消审批的原因"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="cancelFlowSubmit()" class="form-btn" type="success">确认取消</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  export default {
    mixins: [Role],
    computed: {
      ...mapState({
        userData: state => state.main.userData,

        contactSelectArr: state => state.main.contactSelectArr,
        contactType: state => state.main.contactType,
      })
    },
    props: ['flow', 'project', 'isLeader', 'isKxLeader', 'isCanCancel'],
    data() {
      return {
        baseURL: axios.defaults.baseURL,
        nowflow: {},
        nowApproval: {},
        selectArr: [],

        cancleStatus: false,
        form: {
          flowId: '',
          remark: '',
        },
      }
    },
    mounted() {
      console.log(this.flow)
    },
    methods: {
      // 审批人也支持表格下载
      isApprovalUser(approvalUserData) {
        let _r = false
        for (let i = 0; i < approvalUserData.length; i++) {
          if (approvalUserData[i].user && approvalUserData[i].user.id == this.userData.id) {
            _r = true
          }
        }
        return _r
      },
      // 编辑的链接生成
      getRouterLink(flowsource, applyId) {
        console.log(flowsource, applyId)

        let projectId = this.project.id
        // 判断当在合同详情中，编辑非独立合同的审批时，projectId需要改成工程ID，因为这时候的flowsource是工程的，也就是11，10等
        // isProject 工程：true 合同：false
        if (!this.project.isProject && this.project.type != 0) {
          // 独立合同(工程/子项目)
          projectId = this.project.projectIds
        }


        let _url = ''
        switch (flowsource) {
          // 工程项目
          case "2":
            _url = '/Project/Create/' + applyId
            break;
          case "4":
            if (this.project.type == 3 || this.project.type == 4) {
              _url = '/Project/CreateBudget/' + projectId + '/' + applyId
            } else {
              _url = '/Project/CreateInvite/' + projectId + '/' + applyId
            }
            break;
          case "10":
            _url = '/Project/CreateInviteApproval/' + projectId + '/' + applyId
            break;
          case "11":
            _url = '/Project/CreateContractApproval/' + projectId + '/' + applyId
            break;
          case "5":
            _url = '/Project/CreateMoneyApproval/' + projectId + '/' + applyId
            break;
          case "13":
            _url = '/Project/CreateUpdateTime/' + projectId + '/' + applyId
            break;
          case "14":
            _url = '/Project/CreatePayApproval/' + projectId + '/' + applyId
            break;

          case "103":
            if (this.project.isProject) {
              this.$router.push({
                path: '/Project/CreateDiscard',
                query: {
                  applyId: applyId,
                  projectId: projectId,
                }
              })
            }else{
              this.$router.push({
                path: '/Contract/CreateDiscard',
                query: {
                  applyId: applyId,
                  contractId: projectId,
                }
              })
            }
            return
            break;

            // 合同
          case "30":
            _url = '/Contract/CreateInviteApproval/' + projectId + '/' + applyId
            break;
          case "31":
            _url = '/Contract/CreateContractApproval/' + projectId + '/' + applyId
            break;
          case "33":
            _url = '/Contract/CreateMoneyApproval/' + projectId + '/' + applyId
            break;
          case "32":
            _url = '/Contract/CreatePayApproval/' + projectId + '/' + applyId
            break;
          default:
            console.log(flowsource)
            this.$message.error("暂未开放该功能")
            return
            break;
        }
        this.$router.push(_url)
      },
      getTime(time) {
        return util.getFormatDate(time, 1)
      },
      // 取消审批提交
      cancelFlowSubmit() {
        ajax.post('/gc/project/flow/cancel', this.form, (res) => {
          this.$message.success("取消审批成功")
          this.$store.commit('set_projectReload', true)
          this.cancleStatus = false
        })
      },
      // 取消审批弹窗
      cancelFlow(flow) {
        this.form.flowId = flow.id
        this.cancleStatus = true
      },
      // 查看审批详情
      projectDetail(id, type) {
        console.log(id + "====" + type)
        let _projectTable = {
          status: true,
          project: this.project,
          applyId: id,
          tableType: type,
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/project/infoFlow.vue